import {
  Avatar,
  Box,
  Button,
  ListItem,
  ListItemAvatar,
  Tooltip,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { NavLink } from "react-router-dom";

const StyledNavLink = styled(NavLink)(() => ({
  textDecoration: "none",
  "&.active .MuiListItem-root": {
    backgroundColor: "rgb(250, 210, 137)",
  },
}));

const NavItem = ({ to, label, icon, open, setOpen }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClick = () => {
    if (isMobile) setOpen(false);
  };
  return (
    <Box>
      <StyledNavLink onClick={handleClick} to={to}>
        <Tooltip
          title={<Typography color="inherit">{label}</Typography>}
          arrow
          placement="right"
        >
          <ListItem
            sx={{
              display: "flex",
              width: "100%",
            }}
            as={Button}
          >
            <ListItemAvatar>
              <Avatar
                sx={{
                  backgroundColor: "#F2C26A",
                  color: "#253257",
                }}
              >
                {icon}
              </Avatar>
            </ListItemAvatar>
            {open && (
              <Typography
                fontFamily="Bebas Neue"
                fontSize="20px"
                fontWeight="0.5rem"
              >
                {label}
              </Typography>
            )}
          </ListItem>
        </Tooltip>
      </StyledNavLink>
    </Box>
  );
};

export default NavItem;
